/* ==========================================================================
   ZONEX PHARMA — Product page behaviour
   Gallery switching, quantity stepper, variant selection, tabs and the
   sticky buy bar. Everything degrades safely: with JavaScript off the first
   image still shows, the form still submits, and the first tab is open.
   ========================================================================== */

(function () {
  'use strict';

  function $(sel, root) {
    return (root || document).querySelector(sel);
  }
  function $$(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function initRoot(root) {
    if (root.dataset.zxpReady === 'true') return;
    root.dataset.zxpReady = 'true';

    /* ------------------------------------------------------------ gallery */

    var thumbs = $$('[data-zxp-thumb]', root);
    var slides = $$('[data-zxp-slide]', root);

    function show(index) {
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
      });
      thumbs.forEach(function (thumb, i) {
        thumb.classList.toggle('is-active', i === index);
        thumb.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        show(i);
      });
    });

    /* ----------------------------------------------------------- quantity */

    $$('[data-zxp-qty]', root).forEach(function (wrap) {
      var input = $('input', wrap);
      if (!input) return;

      $$('[data-zxp-qty-step]', wrap).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = parseInt(btn.dataset.zxpQtyStep, 10) || 1;
          var min = parseInt(input.getAttribute('min'), 10) || 1;
          var next = (parseInt(input.value, 10) || min) + step;
          input.value = Math.max(min, next);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });

    /* ------------------------------------------------------------ variants */

    var dataEl = $('[data-zxp-variants]', root);
    var idInput = $('.product-variant-id', root);

    if (dataEl && idInput) {
      var variants = [];
      try {
        variants = JSON.parse(dataEl.textContent);
      } catch (err) {
        variants = [];
      }

      var optionInputs = $$('[data-zxp-option]', root);

      function currentOptions() {
        var chosen = [];
        optionInputs.forEach(function (input) {
          if (input.checked) chosen[parseInt(input.dataset.zxpOption, 10)] = input.value;
        });
        return chosen;
      }

      function matchVariant(chosen) {
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          var ok = true;
          for (var j = 0; j < chosen.length; j++) {
            if (chosen[j] !== undefined && v.options[j] !== chosen[j]) {
              ok = false;
              break;
            }
          }
          if (ok) return v;
        }
        return null;
      }

      function updateFor(variant) {
        var priceNow = $('[data-zxp-price-now]', root);
        var priceWas = $('[data-zxp-price-was]', root);
        var skuRow = $('[data-zxp-sku-row]', root);
        var skuVal = $('[data-zxp-sku]', root);
        var priceOff = $('[data-zxp-price-off]', root);
        var submit = $('[data-zxp-submit]', root);
        var submitText = submit ? submit.querySelector('span') : null;
        var stock = $('[data-zxp-stock]', root);

        if (!variant) {
          if (submit) {
            submit.setAttribute('disabled', 'disabled');
            if (submitText) submitText.textContent = submit.dataset.zxpUnavailable || 'Unavailable';
          }
          idInput.value = '';
          return;
        }

        idInput.value = variant.id;

        if (priceNow) priceNow.innerHTML = variant.price;

        /* the SKU belongs to the variant, so it moves with it; the whole row
           hides when a variant has no SKU rather than showing an empty label */
        if (skuRow && skuVal) {
          skuVal.textContent = variant.sku || '';
          skuRow.hidden = !variant.sku;
        }
        if (priceWas) {
          priceWas.innerHTML = variant.compare_at || '';
          priceWas.hidden = !variant.compare_at;
        }
        if (priceOff) {
          priceOff.textContent = variant.saving || '';
          priceOff.hidden = !variant.saving;
        }

        if (submit) {
          if (variant.available) {
            submit.removeAttribute('disabled');
            if (submitText) submitText.textContent = submit.dataset.zxpAdd || 'Add to cart';
          } else {
            submit.setAttribute('disabled', 'disabled');
            if (submitText) submitText.textContent = submit.dataset.zxpSoldOut || 'Sold out';
          }
        }

        if (stock) {
          stock.classList.toggle('zxp-info__stock--out', !variant.available);
          var text = stock.querySelector('[data-zxp-stock-text]');
          if (text) {
            text.textContent = variant.available
              ? stock.dataset.zxpIn || 'In stock'
              : stock.dataset.zxpOut || 'Out of stock';
          }
        }

        // Jump the gallery to the image attached to this variant, if any
        if (variant.media_index !== null && variant.media_index !== undefined) {
          show(variant.media_index);
        }

        // Keep the address bar honest so a shared link opens the same variant
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      optionInputs.forEach(function (input) {
        input.addEventListener('change', function () {
          updateFor(matchVariant(currentOptions()));
        });
      });
    }

    /* --------------------------------------------- tidy the description */

    /* The product descriptions were pasted out of Word: every line is its own
       <p class="MsoNormal"> carrying inline font sizes, headings are just bold
       text, bullets are a literal "·", and the composition uses dot leaders.
       Rebuild that into real headings, lists and a table so it reads properly.
       Wrapped in try/catch: if anything is unexpected the original stays. */
    function tidyDescription(rte) {
      if (!rte || rte.dataset.zxpTidy === 'true') return;
      rte.dataset.zxpTidy = 'true';

      try {
        // 1. Drop Word's inline styling so the stylesheet controls everything
        $$('[style]', rte).forEach(function (el) {
          el.removeAttribute('style');
        });
        $$('[lang]', rte).forEach(function (el) {
          el.removeAttribute('lang');
        });
        $$('[class]', rte).forEach(function (el) {
          if (/Mso/i.test(el.className)) el.removeAttribute('class');
        });

        var blocks = $$('p', rte);
        var compositionRows = [];
        var bulletRun = [];

        function flushBullets(before) {
          if (!bulletRun.length) return;
          var ul = document.createElement('ul');
          bulletRun.forEach(function (item) {
            var li = document.createElement('li');
            li.textContent = item.text;
            ul.appendChild(li);
            item.node.parentNode.removeChild(item.node);
          });
          if (before && before.parentNode) before.parentNode.insertBefore(ul, before);
          else rte.appendChild(ul);
          bulletRun = [];
        }

        blocks.forEach(function (node) {
          var text = (node.textContent || '').replace(/\u00a0/g, ' ').trim();

          // Empty spacer paragraphs
          if (!text) {
            node.parentNode.removeChild(node);
            return;
          }

          // A line that is entirely bold MIGHT be a heading — but the source
          // also bolds whole sentences, so require it to look like a label:
          // short, few words, and no closing full stop.
          var bold = node.querySelector('b, strong');
          var boldText = bold ? bold.textContent.replace(/\u00a0/g, ' ').trim() : '';
          var allBold = bold && boldText.length > 2 && boldText.length >= text.length - 2;

          var label = boldText.replace(/[:：]\s*$/, '').trim();
          var words = label.split(/\s+/).length;
          var known = /^(composition|benefits|dosage|directions|instructions|storage|warnings?|precautions?|side effects?|therapeutic class|packing size|each (tablet|capsule|sachet|5ml|10ml) contains|product enlistment no|indications?|uses?)$/i;

          var isHeading =
            allBold &&
            (known.test(label) || (label.length <= 42 && words <= 5 && !/[.]$/.test(label)));

          if (isHeading) {
            flushBullets(node);
            var h = document.createElement('h3');
            h.textContent = label;
            node.parentNode.replaceChild(h, node);
            return;
          }

          // Bullet lines: "·  Something"
          var bulletMatch = text.match(/^[·•\u00b7]\s*(.+)$/);
          if (bulletMatch) {
            bulletRun.push({ node: node, text: bulletMatch[1].trim() });
            return;
          }

          // A line that starts mid-sentence is the tail of the bullet above it
          // (the source wraps long bullets onto a second paragraph).
          if (bulletRun.length && /^[a-z,]/.test(text)) {
            var last = bulletRun[bulletRun.length - 1];
            last.text = (last.text + ' ' + text).replace(/\s+/g, ' ').trim();
            node.parentNode.removeChild(node);
            return;
          }

          // Body text that happens to be bold in the source should read as
          // body text, not as a shout.
          if (allBold) {
            var plain = document.createElement('p');
            plain.textContent = text;
            node.parentNode.replaceChild(plain, node);
            node = plain;
          }

          flushBullets(node);

          // Composition lines: "Calcium Carbonate (USP)….…400mg"
          var comp = text.match(/^(.+?)[.…·\s]{3,}([\d.,]+\s*[A-Za-z%µ]+)$/);
          if (comp) {
            compositionRows.push({ node: node, name: comp[1].trim(), value: comp[2].trim() });
          }
        });

        flushBullets(null);

        // 2. Turn the run of composition lines into a table
        if (compositionRows.length >= 2) {
          var table = document.createElement('table');
          table.className = 'zxp-comp';
          var tbody = document.createElement('tbody');

          compositionRows.forEach(function (row) {
            var tr = document.createElement('tr');
            var td1 = document.createElement('td');
            td1.textContent = row.name;
            var td2 = document.createElement('td');
            td2.textContent = row.value;
            tr.appendChild(td1);
            tr.appendChild(td2);
            tbody.appendChild(tr);
          });

          table.appendChild(tbody);
          var first = compositionRows[0].node;
          if (first.parentNode) first.parentNode.insertBefore(table, first);
          compositionRows.forEach(function (row) {
            if (row.node.parentNode) row.node.parentNode.removeChild(row.node);
          });
        }
      } catch (err) {
        /* leave the description exactly as it was */
      }
    }


    /* ------------------------------------------------------ accordions */

    /* Each heading the tidier produced — Composition, Dosage, Instructions
       and so on — becomes a collapsible row, so the page opens short and the
       visitor reads only what they want. Anything above the first heading
       (the enlistment number, for instance) stays visible.

       Driven entirely by the headings, so a product added later behaves the
       same with no theme work. A description with no headings is left alone. */
    function buildAccordions(rte) {
      if (!rte || rte.dataset.zxpAccordion === 'true') return;

      var heads = $$('h2, h3', rte);
      if (!heads.length) return;

      rte.dataset.zxpAccordion = 'true';
      var wrap = document.createElement('div');
      wrap.className = 'zxp-acc';

      heads.forEach(function (head, i) {
        var item = document.createElement('div');
        item.className = 'zxp-acc__item';

        var id = 'zxp-acc-' + i + '-' + Math.random().toString(36).slice(2, 7);

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'zxp-acc__head';
        btn.setAttribute('aria-expanded', 'false');
        btn.setAttribute('aria-controls', id);

        var label = document.createElement('span');
        label.className = 'zxp-acc__label';
        label.textContent = head.textContent.trim();
        btn.appendChild(label);

        var chev = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        chev.setAttribute('class', 'zxp-acc__chev');
        chev.setAttribute('viewBox', '0 0 14 9');
        chev.setAttribute('fill', 'none');
        chev.setAttribute('aria-hidden', 'true');
        var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        path.setAttribute('d', 'M1 1.5 7 7.5 13 1.5');
        path.setAttribute('stroke', 'currentColor');
        path.setAttribute('stroke-width', '2');
        path.setAttribute('stroke-linecap', 'round');
        path.setAttribute('stroke-linejoin', 'round');
        chev.appendChild(path);
        btn.appendChild(chev);

        var panel = document.createElement('div');
        panel.className = 'zxp-acc__panel';
        panel.id = id;
        panel.hidden = true;

        // Everything between this heading and the next one belongs to it
        var node = head.nextSibling;
        while (node && !(node.nodeType === 1 && /^H[23]$/.test(node.tagName))) {
          var next = node.nextSibling;
          panel.appendChild(node);
          node = next;
        }

        // A heading immediately followed by another heading has nothing to
        // show — "Composition" sitting straight above "Each tablet contains",
        // for instance. Drop it rather than offer a row that opens on nothing.
        if (!panel.textContent.trim() && !panel.querySelector('img, table')) {
          if (head.parentNode) head.parentNode.removeChild(head);
          return;
        }

        btn.addEventListener('click', function () {
          var open = btn.getAttribute('aria-expanded') === 'true';
          btn.setAttribute('aria-expanded', open ? 'false' : 'true');
          panel.hidden = open;
        });

        item.appendChild(btn);
        item.appendChild(panel);
        wrap.appendChild(item);

        if (head.parentNode) head.parentNode.removeChild(head);
      });

      if (wrap.children.length) rte.appendChild(wrap);
    }

    $$('[data-zxp-tidy]', root).forEach(function (rte) {
      tidyDescription(rte);
      buildAccordions(rte);
    });

    /* ---------------------------------------------------------------- tabs */

    var tablist = $('[data-zxp-tabs]', root);
    if (tablist) {
      var tabs = $$('[role="tab"]', tablist);

      function select(tab) {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.setAttribute('tabindex', on ? '0' : '-1');
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
      }

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () {
          select(tab);
        });
        tab.addEventListener('keydown', function (e) {
          var next = null;
          if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
          if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
          if (next) {
            e.preventDefault();
            select(next);
            next.focus();
          }
        });
      });
    }

    /* --------------------------------------------------------- sticky bar */

    var sticky = $('[data-zxp-sticky]', root);
    var anchor = $('[data-zxp-buy-anchor]', root);

    if (sticky && anchor && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          // Show the bar only once the real buttons have scrolled out of view
          sticky.classList.toggle('is-on', !entries[0].isIntersecting);
        },
        { rootMargin: '0px 0px -40px 0px' }
      );
      observer.observe(anchor);
    }

    // The sticky Add to cart just submits the real form
    $$('[data-zxp-sticky-add]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var submit = $('[data-zxp-submit]', root);
        if (submit && !submit.hasAttribute('disabled')) submit.click();
      });
    });
  }

  function boot() {
    $$('[data-zxp-root]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
